import GenericTable from "../common/genericTable";
import {BsDownload, BsTrash} from "react-icons/bs";
import {useDispatch, useSelector} from "react-redux";
import {deleteUploadedFile, getUploadedFile} from "../../actions/uploads";
import fileDownload from "js-file-download";
import React, {useEffect, useState} from "react";
import ConfirmDialog from "../common/confirmDialog";
import {userCanAccess} from "../../utils/users";

const columns =  [
  {name: 'downloadFile', label: 'Download File', hideLabel: true},
  {name: 'userFileName', label: 'File Name'},
  {name: 'fileType', label: 'File Type'},
  {name: 'fileStatus', label: 'File Status'},
  {name: 'dateUploaded', label: 'Uploaded Date'},
  {name: 'uploadedBy', label: 'Who Uploaded'},
  {name: 'deleteFile', label: 'Delete File', hideLabel: true},
];

const FileList = (props) => {
  const {
    files,
    school,
    currentUserComposite
  } = props;

  const dispatch = useDispatch();

  function formatDateUploaded(dateUploaded) {
    if (!dateUploaded || dateUploaded === '-----------') {
      return '-----------';
    }

    const uploadDate = new Date(dateUploaded);

    return (dateUploaded) ? new Intl.DateTimeFormat("en-US", {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).format(uploadDate) : '';
  }

  const [fileDownloadName, setFileDownloadName] = useState('');
  const [deleteFile, setDeleteFile] = useState(null);
  const [deleteFileConfirmation, setDeleteFileConfirmation] = useState(false);

  const downloadedFile = useSelector((store) => store.uploads.downloadedFile);

  const downloadClick = async (file) => {
    const bucket = await file.fileLocation.replace(/\/+$/, '');
    await dispatch(getUploadedFile(bucket, file.fileName));
    await setFileDownloadName(file.userFileName);
  }

  const deleteClick = async (file) => {
    await setDeleteFile(file);
    await setDeleteFileConfirmation(true);
  }

  const handleDeleteFile = async () => {
    await setDeleteFileConfirmation(false);
    const bucket = await deleteFile.fileLocation.replace(/\/+$/, '');
    await dispatch(deleteUploadedFile(bucket, deleteFile.fileName));
    setDeleteFile(null);
  }

  useEffect(() =>  {
      if (downloadedFile && fileDownloadName) {
        setFileDownloadName('');
        fileDownload(downloadedFile, fileDownloadName);
      }
    }, [dispatch, downloadedFile, fileDownloadName]
  );

  function prepareColumns () {
    return columns.map((column) => {
      switch (column.name) {
        case 'dateUploaded':
          column.onDisplay = (item, column) => {
            return formatDateUploaded(item.dateUploaded);
          };
          return column;
        case 'downloadFile':
          if (userCanAccess(currentUserComposite, 'download-data')) {
            column.onDisplay = (item, column) => {
              return (item.userFileName !== '-----------') ? <button onClick={() => {downloadClick(item)}} className='file-action-button'><BsDownload/></button> : '';
            };
          }
          return column;
        case 'deleteFile':
          if (userCanAccess(currentUserComposite, 'delete-data')) {
            column.onDisplay = (item, column) => {
              return (item.userFileName !== '-----------') ? <button onClick={() => {deleteClick(item)}} className='file-action-button hide'><BsTrash/></button> : '';
            };
          }
          return column;
        case 'fileStatus':
            column.onDisplay = (item, column) => {
              return (item.fileStatus === 'Error') ? <span className='file-status-error'><a href={"/#/error-report"}>{item.fileStatus}</a></span> : item.fileStatus;
            }
          return column;
        default:
          return column;
      }
    });
  }

  return (
    <div className='files-list'>
      <div className='files-header'>
        <div className='school-name'>
          {school}
        </div>
        <div className='report-links-container'>
          {/* <div className='report-links'>
            Data Verification | Preliminary Reports | Final Reports
          </div> */}
        </div>
      </div>
      <div>
        {(deleteFile) && <ConfirmDialog
          showModal={deleteFileConfirmation}
          title='Confirm Delete'
          message={`You are about to delete a file, would you like to proceed?`}
          showCancelButton={true}
          onDismiss={() => {
            setDeleteFileConfirmation(false);
            setDeleteFile(null);
          }}
          onConfirm={handleDeleteFile}
        />}
      </div>
      {<GenericTable
        tableData={(files) ? files : []}
        cols={prepareColumns(columns)}
        emptyMessage='There are no files uploaded at this time.'
        sortAction={() => {}}
      />}
    </div>
  );
}

export default FileList;